/**
 * Fase 2A · P0-4 · BottomNav
 * Navegación bottom mobile-only por rol. Blueprint §17.3.
 * Solo se renderiza en <md. Se oculta en desktop.
 */
import { NavLink } from "react-router-dom";
import {
  House, ChartBar, CalendarBlank, AddressBook, ChatCircleDots,
  User as UserIcon, Scales, ChartLineUp, DotsThreeOutline, Storefront,
} from "@phosphor-icons/react";

const NAV_BY_ROLE = {
  admin: [
    { to: "/", label: "Inicio", icon: ChartBar, end: true },
    { to: "/calendar", label: "Agenda", icon: CalendarBlank },
    { to: "/customers", label: "Clientes", icon: AddressBook },
    { to: "/chats", label: "Chats", icon: ChatCircleDots },
    { to: "/settings", label: "Más", icon: DotsThreeOutline },
  ],
  colaborador: [
    { to: "/", label: "Inicio", icon: House, end: true },
    { to: "/calendar", label: "Agenda", icon: CalendarBlank },
    { to: "/customers", label: "Clientes", icon: AddressBook },
    { to: "/chats", label: "Chats", icon: ChatCircleDots },
    { to: "/my-invoice", label: "Factura", icon: DotsThreeOutline },
  ],
  gestor: [
    { to: "/", label: "Inicio", icon: ChartBar, end: true },
    { to: "/tax", label: "AEAT", icon: Scales },
    { to: "/expenses", label: "Gastos", icon: ChartLineUp },
    { to: "/my-settings", label: "Perfil", icon: UserIcon },
  ],
  empleado: [
    { to: "/", label: "Inicio", icon: House, end: true },
    { to: "/empleado/agenda", label: "Agenda", icon: CalendarBlank },
    { to: "/empleado/clientes", label: "Clientes", icon: AddressBook },
    { to: "/chats", label: "Chats", icon: ChatCircleDots },
    { to: "/empleado/mi-perfil", label: "Perfil", icon: UserIcon },
  ],
};

export default function BottomNav({ role }) {
  const items = NAV_BY_ROLE[role] || NAV_BY_ROLE.admin;

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-[var(--ag-midnight)]/95 backdrop-blur border-t border-[var(--ag-border)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      data-testid="bottom-nav"
      aria-label="Navegación principal"
    >
      <ul className="flex items-stretch justify-around">
        {items.map(({ to, label, icon: Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2 min-h-[52px] text-[10px] uppercase tracking-wider transition-colors ${
                  isActive
                    ? "text-[var(--ag-gold)] font-bold"
                    : "text-[var(--ag-text-dim)] hover:text-white"
                }`
              }
              data-testid={`bottom-nav-${label.toLowerCase()}`}
            >
              {({ isActive }) => (
                <>
                  <Icon size={20} weight={isActive ? "fill" : "regular"} />
                  <span className="truncate max-w-full px-1">{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
